import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { NeedleSizesController } from './needle-sizes-controller';
import { NeedleSizes } from './needle-sizes-entity';
import { NeedleSizesService } from './needle-sizes-service';
import { NeedleSizesRepository } from './needle-sizes-repo';


@Module({
  imports:[TypeOrmModule.forFeature([NeedleSizes])],
  controllers: [NeedleSizesController],
  providers: [NeedleSizesService,NeedleSizesRepository]
})
export class NeedleSizesModule {}
